ADDITIONAL_MENU_KEYS =
  FILE_SHARING_LINK: '[file sharing link]'
  LINK_TO_CABINET: '[link to cabinet]'
  SUBSCRIPTION_LINK: '[subscription link]'
  EMAIL_SUPPORT: '[email support]'
  ACCOUNT: '[account]'
  ACCOUNT_TASK: '[account_task]'

module.exports = { ADDITIONAL_MENU_KEYS }